<template>
  <header class="header">
    <div class="header-actions">
      <router-link to="/" class="logo-link">
        <img src="@/assets/device-tracker-label-icon-v2.png" alt="Nordeus" class="logo"/>
      </router-link>
<!--      <h1>{{ title }}</h1>-->
    </div>
    <div class="header-actions">
      <router-link v-if="backTo" :to="backTo" class="back-btn">← {{ backText }}</router-link>
      <slot name="actions"></slot>
    </div>
  </header>
</template>

<script setup>
import { COLORS, FONTS } from '@/styles/brand'

defineProps({
  title: {
    type: String,
    required: true
  },
  backTo: {
    type: String,
    default: null
  },
  backText: {
    type: String,
    default: 'Back'
  }
})
</script>

<style scoped>
.header {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(20, 64, 154, 0.8) 50%, rgba(31, 31, 79, 0.9) 100%);
  border-bottom: 1px solid #000000;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.logo-link {
  text-decoration: none;
}

.logo {
  height: 40px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.header-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.header-actions h1 {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-family: v-bind('FONTS.PRIMARY');
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.back-btn {
  padding: 8px 12px;
  background: v-bind('COLORS.SECONDARY.DARK_BLUE');
  color: v-bind('COLORS.PRIMARY.WHITE');
  border: 2px solid v-bind('COLORS.SECONDARY.BLUE');
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.back-btn:hover {
  transform: translateY(-2px) scale(1.05);
  background: v-bind('COLORS.SECONDARY.BLUE');
  color: v-bind('COLORS.PRIMARY.WHITE');
  border-color: v-bind('COLORS.SECONDARY.BLUE');
}
</style>
